import React, { Fragment, useMemo } from "react";
import { useDidMount } from "react-hooks-lib";
import styled from "styled-components";
import { View, Text, Link, Divider } from "./components";
import { Header, MobileHeader } from "./App";
import Footer from "./Footer";
import { scrollDown } from "./App";
import { Helmet } from "react-helmet";

import * as data from "./data";

const Container = styled(View)`
  & p:first-of-type {
    margin-top: 0;
  }
`;

const Box = styled(View)`
  display: flex;
  @media (max-width: 870px) {
    & > :first-child {
      flex: 0.85;
    }
  }
  @media (max-width: 820px) {
    & > :first-child {
      flex: 0.65;
    }
  }
  @media (max-width: 440px) {
    display: block;
  }
`;

const Flex = styled(View)`
  flex: 1;
`;

export default function ContactPage(props) {
  useDidMount(() => scrollDown());

  return (
    <View>
      <Helmet>
        <title>Contact • House Of Orange Agency • Amsterdam</title>
        <meta
          name="og:title"
          content={`Contact • House Of Orange Agency • Amsterdam`}
        />
      </Helmet>
      {props.isWide ? <Header /> : <MobileHeader />}
      <Container py={[3, 4, 5]} my={[0, 1, 2]}>
        <Box>
          <Flex>
            <Text mb={2}>House Of Orange</Text>
          </Flex>
          <Flex>
            <Text textStyle="bread">
              <p>
                Founded in October 1995, House of Orange serves the
                international fashion industry, ranging from high-end to
                cutting-edge. With a roster of over 40 top stylists,
                hairstylists, makeup artists, and an ambitious production team,
                the agency handles projects ranging from catwalk shows to
                campaigns and set design.
              </p>
              <p>
                Rather than simply managing creative careers, House of Orange
                represents a loyal family of passionately talented, highly
                professional, yet charmingly authentic individuals. It has
                earned an international reputation for setting new style
                standards by successfully combining individual creative
                excellence with immaculate service and communication.
              </p>
            </Text>
          </Flex>
        </Box>
        <Box>
          <Flex> </Flex>
          <Flex>
            <Divider mb={3} />
          </Flex>
        </Box>
        <Box>
          <Flex>
            <Text mb={2}>Contact</Text>
          </Flex>
          <Flex>
            <Text textStyle="bread">
              <p>
                <Link
                  textStyle="bread"
                  invert
                  as="a"
                  target="_blank"
                  href={data.googleMapsUrl}
                >
                  Leidsegracht 6H
                  <br />
                  1016 CK Amsterdam
                  <br />
                  The Netherlands
                </Link>
              </p>
              <p>
                <Link textStyle="bread" invert as="a" href="tel:+31206223303">
                  +31 (0)20 622 3303
                </Link>
                <br />
                <Link
                  textStyle="bread"
                  invert
                  as="a"
                  href="mailto:info@houseoforange.nl"
                >
                  info@houseoforange.nl
                </Link>
              </p>
            </Text>
          </Flex>
        </Box>
        <Box>
          <Flex> </Flex>
          <Flex>
            <Divider mb={3} />
          </Flex>
        </Box>
        <Box>
          <Flex>
            <Text mb={2}>Agents</Text>
          </Flex>
          <Flex>
            <Text textStyle="bread">
              <p>
                <Link
                  textStyle="bread"
                  invert
                  as="a"
                  href="mailto:erik@houseoforange.nl"
                >
                  Erik van Dillen
                </Link>
                <br />
                <Link
                  textStyle="bread"
                  invert
                  as="a"
                  href="mailto:manon@houseoforange.nl"
                >
                  Manon Meijerman
                </Link>
              </p>
            </Text>
          </Flex>
        </Box>
        <Box>
          <Flex> </Flex>
          <Flex>
            <Divider mb={3} />
          </Flex>
        </Box>
        <Box>
          <Flex>
            <Text mb={2}>Finance</Text>
          </Flex>
          <Flex>
            <Text textStyle="bread">
              <Link
                textStyle="bread"
                invert
                as="a"
                href="mailto:nina@houseoforange.nl"
                style={{ display: "block" }}
              >
                Nina Oliver
              </Link>
              <Link
                textStyle="bread"
                invert
                as="a"
                href="mailto:solange@houseoforange.nl"
                style={{ display: "block" }}
              >
                Solange Clercx
              </Link>
              <p>
                <Link
                  textStyle="bread"
                  invert
                  as="a"
                  href="mailto:finance@houseoforange.nl"
                >
                  finance@houseoforange.nl
                </Link>
              </p>
            </Text>
          </Flex>
        </Box>
        <Box>
          <Flex> </Flex>
          <Flex>
            <Divider mb={3} />
          </Flex>
        </Box>
        <Box>
          <Flex>
            <Text mb={2}>Terms &amp; Conditions</Text>
          </Flex>
          <Flex>
            <Link
              as="a"
              href="/House-of-Orange-Agency-BV-T&C.pdf"
              textStyle="bread"
              invert
            >
              Hair, Make Up & Styling
            </Link>
            <br />
            <Link
              as="a"
              href="/House-of-Orange-Agency-BV-general-purchase-conditions.pdf"
              textStyle="bread"
              invert
            >
              General Purchase Conditions
            </Link>
            <br />
            <Link
              as="a"
              href="/House-of-Orange_Makeup_School_AVG_2023.pdf"
              textStyle="bread"
              invert
              mt={3}
              block
            >
              Privacy / AVG - House of Orange Make-up School
            </Link>
            <Link
              as="a"
              href="/General_Term_&_Conditions-House_of_Orange_Make-up_School.pdf"
              textStyle="bread"
              invert
              block
            >
              General Terms & Conditions - House of Orange Make-up School
            </Link>
          </Flex>
        </Box>
        <div className="header-offset" />
      </Container>
      <Footer isWide={props.isWide} />
    </View>
  );
}
